export default "/images/f5bfd90d0d1140afad7a4a814f7c1b2e.avif";